// TagToggle theme
//
// Brand-only, two hierarchies (subtle / solid), three sizes.
// Verified against Figma file VPUW5N9Dng7UTK3YX5RJlY:
// - node 130:858 (✅ Tag Toggle) — component overview.
// - node 1222:2341 (Tag / Toggle state matrix) — per-size dimensions and per-state colors
//   (Default/Hover/Active × subtle/solid × xs/sm/md), confirmed via each symbol's bound variables.
// borderRadius is a flat 6px on every size, matching Tag's own convention (see ../tag/theme.ts).
//
// Default (unselected): subtle → white bg; solid → brand subtle bg. Both use brand subtle-inverse text.
// Selected: subtle → brand subtle bg; solid → brand solid bg (brand solid-inverse text).
// Figma has no dedicated selected-hover/pressed tokens, so those reuse the hierarchy's own hover token.

const baseStyle = {}

const defaultProps = {
  size: 'md',
  variant: 'solid',
  fontWeight: 'medium',
}

const parts = ['container', 'icon']

const sizes = {
  xs: {
    container: { fontSize: 'sm', h: 20, paddingX: 4, paddingY: 2, gapX: 4, borderRadius: 6 },
    icon: { size: 'xs' },
  },
  sm: {
    container: { fontSize: 'sm', h: 24, paddingX: 6, paddingY: 4, gapX: 6, borderRadius: 6 },
    icon: { size: 'xs' },
  },
  md: {
    container: { fontSize: 'sm', h: 32, paddingX: 8, paddingY: 6, gapX: 8, borderRadius: 6 },
    icon: { size: 'sm' },
  },
}

// Each hierarchy is one variant object; `container.selected` overrides colors when isSelected is
// true (TagToggle merges it in at render time, no `${variant}Selected` key).
// Selected hover/press reuse the hierarchy's own tokens but in the opposite direction from
// unselected (which darkens as a "becoming selected" preview), so a hovered selected tag is
// never the same color as a hovered unselected one.
const variants = {
  // --- subtle: Default=white, Hover=subtle-hover, Active=subtle ---------
  subtle: {
    container: {
      bg: 'white',
      color: 'var(--vui-action-brand-subtle-inverse)',
      bgHover: 'var(--vui-action-brand-subtle-hover)',
      bgPressed: 'var(--vui-action-brand-subtle)',
      selected: {
        bg: 'var(--vui-action-brand-subtle)',
        bgHover: 'var(--vui-action-brand-subtle-pressed)',
        bgPressed: 'var(--vui-action-brand-subtle-hover)',
      },
    },
  },

  // --- solid: Default=subtle, Hover=solid-hover, Active=solid -----------
  // Text stays dark (subtle-inverse) at rest but flips to white (solid-inverse) on hover/press,
  // since the background darkens sharply in those states — confirmed against Figma text fills.
  solid: {
    container: {
      bg: 'var(--vui-action-brand-subtle)',
      color: 'var(--vui-action-brand-subtle-inverse)',
      hoverColor: 'var(--vui-action-brand-solid-inverse)',
      activeColor: 'var(--vui-action-brand-solid-inverse)',
      bgHover: 'var(--vui-action-brand-solid-hover)',
      bgPressed: 'var(--vui-action-brand-solid)',
      selected: {
        bg: 'var(--vui-action-brand-solid)',
        color: 'var(--vui-action-brand-solid-inverse)',
        bgHover: 'var(--vui-action-brand-solid-pressed)',
        bgPressed: 'var(--vui-action-brand-solid-hover)',
      },
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
